import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '@/components/Hero';
import FAQItem from '@/components/FAQItem';
import Testimonials from '@/components/Testimonials';
import StickyBookingButton from '@/components/StickyBookingButton';
import { Star } from 'lucide-react';

// Import refactored components
import TourQuickInfoBar from '@/components/tours/les/TourQuickInfoBar';
import TourOverview from '@/components/tours/les/TourOverview';
import TourHighlights from '@/components/tours/les/TourHighlights';
import TourBookingSection from '@/components/tours/les/TourBookingSection';
import OtherTours from '@/components/tours/les/OtherTours';
import TourStructuredData from '@/components/tours/TourStructuredData';

// Import data
import { testimonials, faqs, fareHarborItemId } from '@/data/lowerEastSideTourData';

const LowerEastSide = () => {
  return (
    <div className="min-h-screen pt-20">
      <Helmet>
        <title>Lower East Side Historical Cat Tour | Cats About Town</title>
        <meta name="description" content="Explore NYC's Lower East Side's gritty history through the stories of its feline residents. Book our unique cat-themed walking tour today!" />
        <meta name="keywords" content="Lower East Side cat tour, NYC cat history, feline walking tour, cat history New York" />
        <link rel="canonical" href="https://catsabouttowntours.com/tours/lower-east-side" />
      </Helmet>
      <TourStructuredData tour={{
        name: 'Lower East Side Cat Tour',
        description: "Explore NYC's Lower East Side's gritty history through the stories of its feline residents.",
        image: '/lovable-uploads/d50c44ab-fa90-46fd-9421-79e3007adbe0.png',
        url: 'https://catsabouttowntours.com/tours/lower-east-side',
        price: '40',
        location: 'Lower East Side'
      }} />
      
      {/* Hero Section */}
      <Hero 
        title="Lower East Side Historical Cat Tour" 
        subtitle="Explore the gritty historical feline tales of NYC's most colorful neighborhood"
        backgroundImage="/lovable-uploads/d50c44ab-fa90-46fd-9421-79e3007adbe0.png"
        height="medium"
        buttonText="Check Availability & Book"
        buttonLink="#book-now"
        showUrgencyMessage={true}
      />
      
      {/* Quick Info Bar */}
      <TourQuickInfoBar />
      
      {/* Tour Overview */}
      <TourOverview />
      
      {/* Tour Highlights */}
      <TourHighlights />
      
      {/* Testimonials Section */}
      <Testimonials testimonials={testimonials} />
      
      {/* Booking Calendar Section */}
      <TourBookingSection itemId={fareHarborItemId} />
      
      {/* FAQ Section */}
      <section className="py-12 bg-[#F5EDE0]">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-playfair font-bold text-2xl md:text-3xl mb-8 text-[#3E2723] text-center">
              Frequently Asked Questions
            </h2>
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <FAQItem 
                  key={index}
                  question={faq.question}
                  answer={faq.answer}
                />
              ))}
            </div>
            
            <div className="text-center mt-10">
              <a href="/contact" className="text-[#D32F2F] hover:underline font-montserrat">
                Have another question? Contact us
              </a>
            </div>
          </div>
        </div>
      </section>
      
      {/* Other Tours */}
      <OtherTours />
      
      {/* Mobile sticky booking button */}
      <StickyBookingButton link="#book-now" />
    </div>
  );
};

export default LowerEastSide;
